<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :class="['resert-password-dialog', 'ah-detail-dialog']"
        top="10vh"
        width="500px"
        append-to-body
        :before-close="handleBeforeClose"
        :lock-scroll="false"
    >
        <template slot="title">
            重設帳號管理員密碼
        </template>
        <div class="detail-row">
            <div class="detail-block">
                <div style="font-size: 13pt; font-weight: normal; margin-bottom: 10px;">重設帳號管理員密碼</div>
                <div style="font-size: 11pt;color: #888;">用於此公司的帳號管理員忘記密碼、或者帳號所有人轉移。</div>
                <div style="margin: 20px 0">
                    <el-button :loading="isLoading" @click="handleSubmitBtn" type="primary">配發新密碼</el-button>
                    <el-input class="passwordInput" readonly v-model="newPassword" style="font-size: 14pt;"></el-input>
                    <div style="font-size: 10pt;color: #888; text-align: center;">（只顯示一次，請複製保存，並告知客戶）</div>
                </div>
                <div style="margin-top: 35px; text-align: left;">
                    <el-button type="" @click="handleCancelBtn">關閉</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'ResetAdminPassDialog',
    props: ['visible'],
    data() {
        return {
            isLoading: false,
            newPassword: null,
        };
    },
    methods: {
        handleBeforeClose() {
            this.isLoading = false;
            this.newPassword = null;
            this.$emit('close');
        },

        handleSubmitBtn() {
            this.$confirm('確定要配發新密碼嗎？', {
                title: '提示',
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.isLoading = true;

                this.$api({
                    url: '/Ahoo/ResetAdmin',
                    method: 'post',
                    data: this.form,
                })
                    .then((resp) => {
                        this.newPassword = resp.data.newPassword;

                        this.$message({
                            showClose: true,
                            message: '密碼已變更。',
                            type: 'success',
                        });
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        },

        handleCancelBtn() {
            this.isLoading = false;
            this.newPassword = null;
            this.$emit('close');
        },
    },
};
</script>
<style lang="scss">
.resert-password-dialog {
    .passwordInput {
        margin: 10px 0;

        .el-input__inner {
            text-align: center;
        }
    }
}
</style>
